// import { TOKEN_DEFAULT_PERMISSIONS_KEY } from '..';

import { captureError } from '@app/lib/Sentry';

export const OIDC_TOKEN_KEY = 'oidc_access_token';

const getAuthToken = (): string | null => {
  if (!localStorage) return null;

  const oidcToken = localStorage.getItem(OIDC_TOKEN_KEY);
  if (oidcToken) return oidcToken;

  return null;
};

const IsTokenExpired = (): boolean => {
  try {
    const token = getAuthToken();
    if (!token) throw new Error('Token is null or undefined');
    const { exp } = parseJwt<{ exp: number }>(token);
    return exp < Date.now() / 1000;
  } catch (err) {
    captureError(err as Error, { context: 'IsTokenExpired - token parsing' });
    return false;
  }
};
// Throws on a malformed token rather than returning null: both callers already sit in a
// try/catch that reports to Sentry, and the underlying error (which character failed to
// decode, which key was missing) is the only part worth reading in that report.
function parseJwt<T>(token: string): T {
  const base64Url = token.split('.')[1];
  if (!base64Url) throw new Error('JWT has no payload segment');

  // The payload is base64url and UTF-8. atob() rejects '-' and '_' outright, so swap them
  // back to the standard alphabet first, then undo atob()'s latin1 reading of the bytes.
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload) as T;
}

export { getAuthToken, IsTokenExpired, parseJwt };
